import * as React from 'react';
import { ThemeContext } from '../../context/theme.context';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { getEvents } from '../../services/events/event';
import { getPlan } from '../../services/ControlCenter/PlanServices';
import { loadingShow } from '../../App';
import { useContext, useEffect } from 'react';
let eventDropDown = new DropDownListComponent({});
let planDropDown = new DropDownListComponent({});
interface IProps {
  theModel: any[];
}
var current_tab = 0;
let thePlanData: Array<any> = [];
const AssignWorkOrderDropdown: React.FC<IProps> = ({ theModel }: IProps) => {
  const [eventsData, setEventsData] = React.useState<Array<any>>([]);
  const [planData, setPlanData] = React.useState<Array<any>>([]);
  const context = useContext(ThemeContext);
  useEffect(() => {
    const fetchData = async () => {
      let theEventID = Number(localStorage.getItem('cs_event_dd_value'));
      let thePlanID = Number(localStorage.getItem('cs_plan_dd_value'));
      await getEvent();
      if (theEventID !== 0 && thePlanID !== 0) {
        if (eventDropDown && eventDropDown !== null)
          eventDropDown.value = theEventID;
        onChangeEvents(false, {
          value: theEventID,
          plan_id: thePlanID,
          isTheSavedPlan: true,
        });
      } else {
      }
    };
    fetchData();
    return () => {
      context.setPlanId(0);
    };
  }, []);
  const getPlans = async (event_id: Number) => {
    await getPlan(event_id).then((res: any) => {
      res.data.unshift({
        plan_name: '',
        ID: -1,
      });
      thePlanData = res.data;
      setPlanData(res.data);
    });
  };
  const getEvent = async () => {
    await getEvents().then((result) => {
      result.data.unshift({
        eventCode: '',
        eventId: -1,
      });
      setEventsData(result.data);
    });
  };
  const onChangeEvents = async (isFirst: boolean, args: any) => {
    const eventId = args.value;
    await getPlans(eventId);
    const plan_id = thePlanData.length > 0 ? thePlanData[1]?.ID : null;
    localStorage.setItem('assign_plan_id_value', plan_id);
    if (eventId === -1) {
      loadingShow(false);
      context.setPlanId(0);
      if (isFirst) {
        context.setMaterialAllowChange(true);
        context.setResourcesAllowChange(true);
      }
      return;
    }
    if (thePlanData.length ===2 || args.isTheSavedPlan) {
      let thePlan = planData[1];
      if (args.isTheSavedPlan) {
        planDropDown && (planDropDown.value = args.plan_id);
        await onChangePlan(isFirst, { value: args.plan_id });
        return;
      }
      if (plan_id !== null) {
        planDropDown && (planDropDown.value = plan_id);
        context.setPlanId(plan_id);
        if (isFirst) {
          context.setResourcesAllowChange(true);
          context.setMaterialAllowChange(true);
        }
      }
    } else {
      context.setPlanId(0);
    }
    loadingShow(false);
  };
  const onChangePlan = async (isFirst: boolean, args: any) => {
    loadingShow(true);
    if (-1 === args.value) {
      context.setPlanId(0);
      if (isFirst) {
        context.setMaterialAllowChange(true);
        context.setResourcesAllowChange(true);
      }
    } else {
      localStorage.setItem('assign_plan_id_value', args.value);
      context.setPlanId(args.value);
      if (isFirst) {
        context.setMaterialAllowChange(true);
        context.setResourcesAllowChange(true);
      }
    }
    loadingShow(false);
  };
  return (
    <div>
      <div
        className='header-cloud-scheduler-fixed'
        style={{
          width: '80%',
          marginTop: '25%',
          marginRight: '12%',
        }}
      >
        <div className='cloud-scheduler-input'>
          <DropDownListComponent
            placeholder='Event'
            ref={(el: DropDownListComponent) => (eventDropDown = el)}
            dataSource={eventsData}
            fields={{ text: 'eventCode', value: 'eventId' }}
            value={0}
            onChange={onChangeEvents.bind(this, true)}
            dataBound={() => {}}
          />
        </div>
        <div className='cloud-scheduler-input'>
          <DropDownListComponent
            ref={(el: DropDownListComponent) => (planDropDown = el)}
            placeholder='Plan'
            dataSource={planData}
            fields={{ text: 'plan_name', value: 'ID' }}
            onChange={onChangePlan.bind(this, true)}
          />
        </div>
      </div>
    </div>
  );
};

export default AssignWorkOrderDropdown;
